import { StatusDot } from '../../ui/StatusDot';
import { Tooltip } from '../../ui/Tooltip';
import { useAuthStore } from '../../../store/auth.store';
import { useUiStore } from '../../../store/ui.store';

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

/** The signed-in user's identity card at the bottom of the sidebar — real session data from the auth store. */
export function SidebarUserCard() {
  const user = useAuthStore((s) => s.user);
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  if (!user) return null;

  const avatar = (
    <div className="relative flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-full bg-primary text-[13px] font-bold text-white">
      {initials(user.name)}
      {collapsed && <StatusDot status={user.status} className="absolute -bottom-0.5 -right-0.5 ring-2 ring-surface" />}
    </div>
  );

  if (collapsed) {
    return (
      <div className="mx-auto flex justify-center py-1">
        <Tooltip label={`${user.name} · ${capitalize(user.role)}`}>{avatar}</Tooltip>
      </div>
    );
  }

  return (
    <div className="mx-1 flex items-center gap-3 rounded-xl bg-surface-hover p-2">
      {avatar}
      <div className="min-w-0 flex-1">
        <p className="truncate text-xs font-semibold text-text-primary">{user.name}</p>
        <p className="truncate text-[11px] text-text-secondary">
          {capitalize(user.role)}
          {user.department ? ` · ${user.department}` : ''}
        </p>
      </div>
      <StatusDot status={user.status} halo />
    </div>
  );
}
